<template>
	<div class="results-box">
		<div v-for="(list, index) in chunkedList" :key="index" class="table">
			<div v-for="(item, itemIndex) in list" :key="itemIndex" class="table-row">
				<div class="results-box-av">
					{{ item.avName }}
				</div>
				<div class="results-box-virus">
					<div v-if="item.virus == ''" class="results-box-notfound">
						<img class="ok-img">
						<div class="results-box-text"> Virus Not Found </div>
					</div>
					<div v-else class="results-box-found">
						<img class="warning-img">
						<div class="results-box-text"> {{ item.virus }} </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {    
		name:'Box',
		props: [
			'results'
		],
		data() {
			return {
				chunkedList: [[],[]]
			}
		},
		methods: {
			spliceIntoParts() {
				if (this.results) {
					const mid = Math.ceil(this.results.length / 2);
					const list = this.results
					this.chunkedList[0] = list.splice(0, mid);
					this.chunkedList[1] = list.splice(-mid);
				}
			}
		},
		mounted() {
			this.spliceIntoParts()
		}
	}
</script>